var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"edit-btn",on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_c('Pen',{attrs:{"iconColor":'#0F1C70'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }